import { render } from "./BillingHisList.vue?vue&type=template&id=7a6dd514"
import script from "./BillingHisList.vue?vue&type=script&lang=js"
export * from "./BillingHisList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__